import { Controller } from 'react-hook-form'

import { InputField } from 'components/InputField'
import Input from 'components/Input'
import { FormsLayout } from 'components/Layout/Forms'
import Button from 'components/Button'
import { MembershipsDataTypes } from 'types/memberships'

import { useMemberMembershipGroupUpdate } from './useMemberMembershipGroupUpdate'
import { useMemberMembershipGroupUpdateForm } from './useMemberMembershipGroupUpdateForm'


const Index = ({
  modalClose,
  selectedRowData,
}: {
  modalClose: () => void
  selectedRowData: MembershipsDataTypes
}): JSX.Element => {
  const {
    memberMembershipGroupUpdateParams,
    memberHandleMembershipGroupUpdate,
  } = useMemberMembershipGroupUpdate({
    modalClose,
    selectedRowData,
  })

  const { control, handleSubmit, setValue, errors } =
    useMemberMembershipGroupUpdateForm({
      defaultValues: {
        ...memberMembershipGroupUpdateParams,
        membershipId: selectedRowData.membershipId,
      },
    })

  return (
    <FormsLayout.Wrapper
      onSubmit={handleSubmit(memberHandleMembershipGroupUpdate)}
    >
      <FormsLayout.Item>
        <Controller
          name="endDate"
          control={control}
          render={({ field }) => (
            <InputField
              onChange={(e) => {
                setValue('endDate', e.target.value)
              }}
              type="date"
              name="endDate"
              label="End Date"
              containerClassName="flex flex-col flex-grow"
              rounded
              error={errors.endDate?.message}
            />
          )}
        />
      </FormsLayout.Item>

      <FormsLayout.ActionWrapper>
        <Button key="submit" type="submit" className="mr-2 rounded bg-primary">
          <span className="tracking-wider font-bold">Update</span>
        </Button>
      </FormsLayout.ActionWrapper>
    </FormsLayout.Wrapper>
  )
}

export default Index
